
export default {
  name: 'MaintenanceAlert',
}
